// Scrolls a positioned scroller so the element sits in its middle, along "x" or "y", without smooth scrolling.
export default function centreInScroller(scroller, element, axis = "x") {
  const [offset, client, size, scroll] = axis === "x"
    ? [element.offsetLeft, scroller.clientWidth, element.offsetWidth, "scrollLeft"]
    : [element.offsetTop, scroller.clientHeight, element.offsetHeight, "scrollTop"];

  scroller.style.scrollBehavior = "auto";
  scroller[scroll] = offset - (client - size) / 2;
  scroller.style.scrollBehavior = "";
}
